const eventRegistration = {
  corro_ninos_2026: {
    titulo: "INSCRIPCIÓN YO CORRO POR LOS NIÑOS 2026",

    tabla: "CORRO_NINOS_2026_INSCRIPCIONES",

    numeroYape: "956280178",

    nombreYape: "AMALIA M. MÁLAGA",

    supabaseUrl:
      "https://niixoqhntxqvqjubeuaj.supabase.co",

    supabasePublishableKey:
      "sb_publishable_GsuSd44LRq1bwW7c1cqeyQ_KN4SFcaX",

    googleAppsScriptUrl:
      "https://script.google.com/macros/s/AKfycbxjQJKclt7mQvj_ykt-J5bbhLxm9AgoEDVd-K9bOFQ8zBXrYTypB67_qerbrh3Naqxq/exec",

    carpetaBienvenidas:
      "1qRbWrj-PpijUeVJxKekW57BFfSzpDXSx",

    carpetaPagos:
      "12T0cnJmXB_zBsFoJIxGzRIZkZaZi7VTX",

    emailServiceId:
      "service_2govrnu",

    emailTemplateId:
      "template_lurswng",

    emailPublicKey:
      "PN9-V6us45efj9uL6"
  },

  corro_ninos_2026_mascotas: {
    titulo: "INSCRIPCIÓN YO CORRO POR LOS NIÑOS 2026 MASCOTAS",

    tabla: "CORRO_NINOS_2026_INSCRIPCIONES_MASCOTAS",

    numeroYape: "956280178",

    nombreYape: "AMALIA M. MÁLAGA",

    supabaseUrl:
      "https://niixoqhntxqvqjubeuaj.supabase.co",

    supabasePublishableKey:
      "sb_publishable_GsuSd44LRq1bwW7c1cqeyQ_KN4SFcaX",

    googleAppsScriptUrl:
      "https://script.google.com/macros/s/AKfycbzsZFGQQ4OHOx1COMJS4YOJ_poYbxsRybmeDpHdwLR9U--RaHGMTE_q9PXClcJtOJhc/exec",

    carpetaBienvenidas:
      "1qRbWrj-PpijUeVJxKekW57BFfSzpDXSx",

    carpetaPagos:
      "12T0cnJmXB_zBsFoJIxGzRIZkZaZi7VTX",

    emailServiceId:
      "service_2govrnu",

    emailTemplateId:
      "template_nmy6i4c",

    emailPublicKey:
      "PN9-V6us45efj9uL6"
  }
};

export default eventRegistration;